import React from 'react';
import { ViolationListMainWrapper } from './ViolationListView.styles';
import ViolationListContent from './ViolationListContent';

const ViolationListContainer: React.FC = () => {
    return (
        <ViolationListMainWrapper>
            <ViolationListContent></ViolationListContent>
        </ViolationListMainWrapper>
    );
};

export default ViolationListContainer;
